const FIREBASEURL = "https://us-central1-festiv-fd5c6.cloudfunctions.net/api"
export default FIREBASEURL